module.exports = __webpack_public_path__ + "files/7311603a0138c8813c695884d6d6c257.png";